// extracted by mini-css-extract-plugin
module.exports = {"themeHeaderIconColor":"#fff","themeIconColor":"#3a7ec3","themeDisabledIconColor":"#656565"};